import { useCallback, useState } from "react";
import { CatalogBuilder } from "../../../../commonGroupModuleStructure/catalogBuilder";
import { MuiRightDrawer } from "../../../../components";
import { APIParams, createRoleApplicationMapping, deleteRoleApplicationMapping, getRoleApplicationMapping, getRoleNotInApplication } from "../apiCall";
import { RoleKeys } from "../entity";
import CheckListSearch from "../../../../components/CheckListSearch";

export const RoleApplicationMapping = (props: any) => {
  const { request } = props;
  const [open, setOpen] = useState(false);

  const onClickPlus = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const getOptions = useCallback(async (params: APIParams) =>
    await getRoleNotInApplication({ ...params, request: { ...params.request, ...request } })
    , [request])

  const onSubmit = useCallback(async (params: APIParams) =>
    await createRoleApplicationMapping({ ...params, request: { ...params.request, ...request } })
    , [request])


  return (
    <>
      <CatalogBuilder
        isHeader={false}
        isPlusButton={true}
        isAssociationButton={true}

        getPagingData={getRoleApplicationMapping}
        pagingAPIrequest={request}
        pagingAPIKey={RoleKeys.getApplicationMapping}

        onDelete={deleteRoleApplicationMapping}
        deletePagingAPIKey={RoleKeys.deleteApplicationMapping}

        visibleColumns={{
          RoleName: false
        }}
        onClickPlus={onClickPlus}
        isRightMenu={true}
        disableEditAction
        disableViewAction
      />
      <MuiRightDrawer open={open} onClose={onClose} width='40%'>
        <CheckListSearch
          getOptions={getOptions}
          displayExpr={'DisplayName'}
          listKey={RoleKeys.notInApplication}
          label='Add Application'
          name='ApplicationId'
          onSubmit={onSubmit}
          onClose={onClose}
          pagingAPIKey={RoleKeys.getApplicationMapping}
        />
      </MuiRightDrawer>
    </>
  );
};
